 import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { TableItemDinamico, dineroDisabledMask, ButtonItem, SegmentedItem, NotificacionMovimientosInventario } from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { CloseCircleOutlined, InboxOutlined, MailOutlined} from "@ant-design/icons";
import ModalMandarCorreoFacturas from "../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
moment.locale('es')

class Remisiones extends Component {
  tableRef = null; 
  state = {
    todasRemisiones: [],
    loading: false,
    valor: 5,
    totalRecords: 0, 
    modalCorreo: false,
    modalCorreoId: null,
  }
  

  consultarRemisiones ( params = {}){
    this.setState({loading: true}); 
    const body = {
      empresaId: this.props.empresaId,
      ...params,
    };

    axios
      .post(
        "remisiones/selectRemisiones",
        body,
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        
        let data = [];
        let total = 0;

        // Soporte para respuesta nueva { success: 2, data: [], totalRecords: N }
        if (res.data.success === 2) {
          data = res.data.data;
          total = res.data.totalRecords;
        } else if (Array.isArray(res.data)) {
          // Soporte legacy
          data = res.data;
          total = res.data.length;
        } else if (res.data.status === 404) {
          data = [];
          total = 0;
        }

        this.setState({
          totalRecords: total,
          todasRemisiones: data.map((value) => {
            return {
              ...value,
              // Usamos proveedorNombre del backend si viene, sino lo armamos
              proveedorNombre: value.proveedorNombre
                ? value.proveedorNombre
                : value.proveedor.nombre
                ? value.proveedor.nombre +
                  " " +
                  value.proveedor.apellidoPaterno +
                  " " +
                  value.proveedor.apellidoMaterno
                : value.proveedor.razonSocial,
              accion: {
                _id: value._id,
                estado: value.estado,
                estadoPago: value.estadoPago,
              },
            };
          }),
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, todasRemisiones: [], totalRecords: 0 });
      });

  }

  agregarRemision() {
    this.props.history.push('/panel/agregarRemision')
  }
  recibirInsumosRemision(id) {
    this.props.history.push('/panel/recibirInsumosRemision', { id })
  }
  cancelarRemision(value) {
    axios
      .post(
        "remisiones/cancelarRemision",
        { remisionId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Remisión cancelada");
          NotificacionMovimientosInventario(res.data.movimientosIds);
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  abrirMandarCorreoFactura(id) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
    });
  }

  cerrarMandarCorreoFactura() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }
  render() {
    const {todasRemisiones, totalRecords, loading} = this.state; 

    const columns = [
      {
        title: "Núm",
        dataIndex: "numeroRemision",
        key: "numeroRemision",
        sorter: (a, b) => {
          if (a.codigoRemision < b.codigoRemision) {
            return -1;
          }
          if (a.codigoRemision > b.codigoRemision) {
            return 1;
          }
          return 0;
        },
        buscar: 'numeroRemision',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Codigo",
        dataIndex: "codigoRemision",
        key: "codigoRemision",
        // sorter: (a, b) => {
        //   if (a.codigoRemision < b.codigoRemision) {
        //     return -1;
        //   }
        //   if (a.codigoRemision > b.codigoRemision) {
        //     return 1;
        //   }
        //   return 0;
        // },
        render: (value) => value,
        buscar: 'codigoRemision',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => {
          if (a.proveedorNombre < b.proveedorNombre) {
            return -1;
          }
          if (a.proveedorNombre > b.proveedorNombre) {
            return 1;
          }
          return 0;
        },
        buscar: 'proveedorNombre',
        width: '30%',
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaRemision",
        key: "fechaRemision",
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          if (moment(a.fechaRemision) < moment(b.fechaRemision)) {
            return -1;
          }
          if (moment(a.fechaRemision) > moment(b.fechaRemision)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '8%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: "Recepción",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        defaultSortOrder: 'descend',
        render: (value, record) => moment(value || record.createdAt).locale('es').format('L'),
        width: '7%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: 'Subtotal / Total',
        dataIndex: 'subtotal',
        key: 'subtotal',
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion }</span>}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: 'totalPagar',
        width: '12%',
        ellipsis: true,
        align: 'right',
      },
      {
        title: 'Total',
        dataIndex: 'totalPagar',
        key: 'totalPagar',
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: 'totalPagar',
        responsive: [],
        width: 0,
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value, record, index) => {
          if (value === 0) {
            return <Tag key={index.toString()} color='red' className="square-tag">Cancelada</Tag>
          }
          if (value === 1) {
            return <Tag key={index.toString()} color='blue' className="square-tag">Sin recibir</Tag>
          }
          if (value === 2) {
            return <Tag key={index.toString()} color='orange' className="square-tag" style={{ fontSize: 10 }}>Recibido parcialmente</Tag>
          }
          if (value === 3) {
            return <Tag key={index.toString()} color='green' className="square-tag">Recibido</Tag>
          }
        },
        width: '13%',
        ellipsis: true,
      },
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: 'center',
        width: '10%',
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          if (value.estado === 0) return null;

          let buttons = [];

          buttons.push(
          <Tooltip title="Mandar correo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <ButtonItem
              key={`correo-${index}`}
              type="default"
              size="small"
              azul
              icon={<MailOutlined />}
              onClick={() => this.abrirMandarCorreoFactura(value._id)}
            />
          </Tooltip>)

          const puedeRecibir = (value.estado === 1 || value.estado === 2) && this.props.permisoRecibirInsumosRemision;
          buttons.push(
            <Tooltip title={puedeRecibir ? "Recibir Insumos" : "No disponible"} key={`recibir-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                azul
                type='default'
                size='small'
                onClick={() => puedeRecibir && this.recibirInsumosRemision(value._id)}
                icon={<InboxOutlined />}
                disabled={!puedeRecibir}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeCancelar = value.estado !== 0 && value.estadoPago === 0 && this.props.permisoCancelarRemision;
          buttons.push(
            <Popconfirm
              key={`cancelar-${index}`}
              title="Seguro que quieres cancelar esta remisión"
              onConfirm={() => this.cancelarRemision(value._id)}
              okText="Si"
              cancelText="No"
              disabled={!puedeCancelar}
            >
              <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type='default'
                  size='small'
                  rojo
                  icon={<CloseCircleOutlined />}
                  disabled={!puedeCancelar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ]
    return (
      <>
        <PageHeader
          title="Remisiones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[
                    { label: "Sin Recibir", value: 1 },
                    { label: "Recibido Parcialmente", value: 2 },
                    { label: "Recibido", value: 3 },
                    { label: "Cancelada", value: 4 },
                    { label: "Todos", value: 5 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarRemision &&
                <ButtonItem
                  type="primary"
                  key="agregarRemision"
                  olivo
                  onClick={this.agregarRemision.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Remisión
                </ButtonItem>}
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)} 
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarRemisiones.bind(this)}
          size="small"
          dataSource={todasRemisiones}
          columns={columns}
          pagination={false}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
          filterStorageKey={"remisionesFiltros" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          
          // Doble click
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verRemision", {
                  id: record._id,
                });
              },
            };
          }}
          locale={{ emptyText: "No se encontraron remisiones" }}
        />
        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarModalMandarCorreoFacturas={this.cerrarMandarCorreoFactura.bind(
            this,
          )}
          tipoFactura ="Remisión"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarRemision: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "000000000000000000000002")?.activado,
    permisoCancelarRemision: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "000000000000000000000003")?.activado,
    permisoRecibirInsumosRemision: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "000000000000000000000004")?.activado,
  };
};

export default connect(mapStateToProps)(Remisiones);